// bao migrate skip
import TabPage from "./../factories/tab-page";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";

/**
 * Represents a tab type in a Work Item interface.
 * Extends the `BaseViewModel` class.
 */
class WorkItemTabType extends BaseViewModel {

    //#region Fields

    WorkItemTabTypeUniversalFieldTab: TabPage;
    WorkItemTabTypeFieldTab: Factories.TabPage;
    WorkItemTabType1: KnockoutObservable<string> = ko.observable();
    WorkItemTabType2: KnockoutObservable<string> = ko.observable();
    WorkItemTabType3: KnockoutObservable<string> = ko.observable();
    WorkItemTabType4: KnockoutObservable<string> = ko.observable();
    WorkItemTabType5: KnockoutObservable<string> = ko.observable();
    Description: KnockoutObservable<string> = ko.observable();
    PreLoad: KnockoutObservable<boolean> = ko.observable();
    AssemblyName: KnockoutObservable<string> = ko.observable();
    ReflectionType: KnockoutObservable<string> = ko.observable();
    WorkItemTabTypeObject: KnockoutObservable<any> = ko.observable({});
    WorkItemTabTypeId: KnockoutObservable<string> = ko.observable();
    AfterInit: KnockoutObservable<boolean> = ko.observable(false);
    ManualCompletion: KnockoutObservable<boolean> = ko.observable(false);

    //#endregion

    //#region Constructors

    /**
     * Creates a new instance of the WorkItemTabType class.
     * @param tabPage - The tab page information.
     */
    constructor(tabPage: TabPage) {
        super(tabPage);
    }

    //#endregion

    //#region Computed Observables

    /**
     * Computes the WorkItemTabType value based on the selected language.
     */
    WorkItemTabType = ko.pureComputed<string>({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.WorkItemTabType1();
                case 2:
                    return this.WorkItemTabType2();
                case 3:
                    return this.WorkItemTabType3();
                case 4:
                    return this.WorkItemTabType4();
                case 5:
                    return this.WorkItemTabType5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.WorkItemTabType1(value);
                    break;
                case 2:
                    this.WorkItemTabType2(value);
                    break;
                case 3:
                    this.WorkItemTabType3(value);
                    break;
                case 4:
                    this.WorkItemTabType4(value);
                    break;
                case 5:
                    this.WorkItemTabType5(value);
                    break;
            }
        }
    });

    //#endregion

    //#region Public Methods

    /**
     * Retrieves the initialization URL for the WorkItemTabType.
     * @returns The URL as a string.
     */
    InitUrl() {
        return "WorkItemTabType/Init";
    }

    /**
     * Opens the translation dialog for the WorkItemTabType.
     */
    Translate() {
        let translateDialog = new TranslateDialogViewModel(this.WorkItemTabType1, this.WorkItemTabType2, this.WorkItemTabType3, this.WorkItemTabType4, this.WorkItemTabType5);
        translateDialog.Open();
    }

    /**
     * Checks whether all mandatory fields are filled for the WorkItemTabType.
     * @returns True if complete, otherwise false.
     */
    CompleteCheck() {
        let isComplete = true;

        if (Bao.Utils.String.IsNullOrEmpty(this.WorkItemTabType())) {
            isComplete = false;
        }

        if(!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }

    //#endregion
}
export default WorkItemTabType;